import { FaGithub, FaInstagram, FaLinkedinIn } from "react-icons/fa";

export const socialLinks = [
  {
    href: "https://www.linkedin.com/in/arianne-roselina-prananto",
    Icon: FaLinkedinIn,
    label: "LinkedIn",
  },
  {
    href: "https://www.instagram.com/arianneroselina",
    Icon: FaInstagram,
    label: "Instagram",
  },
  {
    href: "https://github.com/arianneroselina",
    Icon: FaGithub,
    label: "GitHub",
  },
];
